<template>
    <div class="submission-setup-wrapper" :class="{'voting-mode' : activePage == 'voting' }" id="submissionSetupWrapper" ref="submissionSetupWrapper">
        <SubmissionDetails v-if="activePage == 'voting'"/>
        <ProductShop v-if="activePage == 'voting'"/>
        <ParticipationForm v-if="activePage == 'registration'"/>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';

import ParticipationForm from '@/components/Pastimes/Desktop/partials/ParticipationForm';
import SubmissionDetails from '@/components/Pastimes/Desktop/partials/SubmissionDetails';
import ProductShop from '@/components/Pastimes/Desktop/partials/ProductShop';

export default {
    store,
    name: 'SubmissionSetup',
    components: {
        ParticipationForm,
        SubmissionDetails,
        ProductShop
    },
    props: {
        //prop1: {type: Object, default: null, required: false}
    },
    data() {
        return {
            //data1: null
        }
    },
    computed: {
        activePage() { 
            return this.$store.getters.activePage;
        },
        registrationInfo() {
            return this.$store.getters['contestantPage/registrationInfo'];
        },
        submissionInformation() {
            return (!isEmpty(this.registrationInfo.productList)) ? this.registrationInfo.productList : null
        },
    },
    watch: {
    },
    created() {
    },
    mounted() {        
    },
    methods: {
        //method1() { }
    }
};
</script>

<style scoped>

</style>